import { useState } from "react";
import { Sidebar } from "../Sidebar";
import { ScenariosTab } from "./CashflowSidebar.Scenarios";
import { Tabs } from "./Tabs";
import { BankBalancesTab } from "./CahsflowSidebar.Banks";

const steps = [
  { id: 1, name: "Bank Balances" },
  { id: 2, name: "Scenarios" },
  //{ id: 2, name: "Quotations" },
];

export function CashflowSidebar({ scenarios, onScenarioChange, onOptionChange, variablesByName, setVariable }) {
  const [currentTab, setCurrentTab] = useState(2);

  return (
    <Sidebar title="" padding="1em 0 0 0">
      <Tabs tabs={steps} currentTab={currentTab} onChange={setCurrentTab} />
      {currentTab === 1 && <BankBalancesTab />}
      {currentTab === 2 && (
        <ScenariosTab
          scenarios={scenarios}
          onScenarioChange={onScenarioChange}
          onOptionChange={onOptionChange}
          variablesByName={variablesByName}
          setVariable={setVariable}
        />
      )}
    </Sidebar>
  );
}
